import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import settings from '../../config';
import Button from '../Button';
import { useParams } from 'react-router-dom';

const Inventory = () => {
  const [accessories, setAccessories] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [operations, setOperations] = useState([]);
  const [updated, setUpdated] = useState(false);

  const { inventoryId } = useParams();

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}accessories/`);

      if (response.data.statusCode === 200) {
        setAccessories(response.data.data);
      }

      const operationResponse = await axios.post(
        `${settings.api}inventory-operation/`,
        {
          inventoryId
        }
      );

      if (operationResponse.data.statusCode === 200) {
        const operations = operationResponse.data.data;
        setOperations(operations);
      }
    })();
  }, [inventoryId]);

  useEffect(() => {
    if (operations.length && !updated) {
      const updatedAccessories = accessories.map((accessory) => {
        const operation = operations.find(
          (operation) => operation.itemId === accessory.accessoryId
        );

        if (operation) {
          return {
            ...accessory,
            ...operation
          };
        } else {
          return accessory;
        }
      });

      setAccessories(updatedAccessories);
      setUpdated(true);
    }
  }, [accessories, operations, operations.length, updated]);

  const onChange = (accessoryId, value) => {
    setAccessories(
      accessories.map((accessory) =>
        accessory.accessoryId === accessoryId
          ? {
              ...accessory,
              actualQuantity: +value
            }
          : accessory
      )
    );
  };

  const onSubmit = useCallback(async () => {
    const payload = {
      inventoryId,
      operations: accessories.map((accessory) => ({
        itemId: accessory.accessoryId,
        actualQuantity: accessory.actualQuantity,
        quantity: accessory.weight - accessory.usedWeight || 0
      }))
    };

    const response = await axios.post(
      `${settings.api}inventory-operation/create`,
      payload
    );

    if (response.data.statusCode === 200) {
      setIsSubmitted(true);
    }
  }, [accessories, inventoryId]);

  return (
    <div className='w-full'>
      <table className='w-full table-auto border-separate border-spacing-1 text-right '>
        <thead>
          <tr>
            <th>اسم الخامه</th>
            {<th>الوزن المتاح</th>}
            {<th>الوزن داخل المخزن</th>}
          </tr>
        </thead>
        <tbody>
          {accessories.map((accessory) => {
            return (
              <tr
                key={accessory.accessoryId}
                className='bg-white odd:bg-gray-100 hover:bg-orange-100'
              >
                <td>{accessory.accessoryName}</td>

                <td className={(!isSubmitted && 'blur-md') || ''}>
                  {(
                    (accessory.weight || 0) - (accessory.usedWeight || 0)
                  ).toLocaleString('en-US')}
                </td>
                <td>
                  <label className='w-full'>
                    <input
                      onChange={(e) =>
                        onChange(accessory.accessoryId, e.target.value)
                      }
                      value={accessory.actualQuantity || 0}
                      className='w-full border rounded-lg my-2 p-2 invalid:border-pink-500 invalid:text-pink-600
              focus:invalid:border-pink-500 focus:invalid:ring-pink-500'
                    />
                  </label>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className='flex justify-center'>
        <Button className='w-1/2 my-5' text='جرد' action={onSubmit} />
      </div>
    </div>
  );
};

export default Inventory;
